import {Popover, TextField} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import React, {useEffect, useState} from "react";
import listRequestWrapper from "../../../../../../../../Services/API/listRequestWrapper";

const AdaptiveLayoutSetup = (props) => {
    const {anchor, onClose, value, apply} = props;
    const isOpen = Boolean(anchor);
    const [adaptiveStyles, setAdaptiveStyles] = useState({});
    const [availableResolutions, setAvailableResolutions] = useState([]);
    useEffect(() => {
        if (!isOpen) return;
        getResolutions();
        setValue();
    }, [isOpen])
    if (!isOpen) return <></>

    async function getResolutions() {
        try {
            const resolutions = await listRequestWrapper('resolution');
            setAvailableResolutions(resolutions)
        } catch (e) {
            console.log(e)
        }
    }

    function setValue() {
        if (typeof value === 'object') {
            let clearValues = {};
            Object.keys(value).map(type => {
                clearValues[type] = value[type].replace(/[^0-9.,]/g, "");
            })
            setAdaptiveStyles(clearValues)
            return;
        }
        if (typeof value === 'string') {
            let clearValue = value.replace(/[^0-9.,]/g, "");
            setAdaptiveStyles({desktop: clearValue})
        }
    }

    function handleInput(e) {
        const {target: {value, name}} = e;
        setAdaptiveStyles(prevState => {
            return {
                ...prevState,
                [name]: value
            }
        })
    }

    return (
        <Popover
            anchorEl={anchor}
            open={isOpen}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
        >
            <div style={{display: 'flex', flexDirection: 'column', padding: 10}}>
                {availableResolutions.map((resolution, index) => (
                    <TextField variant={'standard'}
                               size={"small"}
                               type={"number"}
                               value={adaptiveStyles[resolution.id]}
                               onChange={handleInput}
                               label={resolution.name}
                               autoFocus={index === 0}
                               name={resolution.id}
                    />
                ))}
                <div style={{padding: '5px 0', display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
                    <Button
                        variant={'contained'} color={'primary'}
                        size={'small'}
                        onClick={() => {
                            apply(adaptiveStyles);
                            onClose();
                        }}
                    >Apply</Button>
                    <Button
                        onClick={onClose}
                        variant={'contained'} color={'default'} size={'small'}
                        style={{marginLeft: 5}}
                    >Cancel</Button>
                </div>
            </div>
        </Popover>
    )
}
export default AdaptiveLayoutSetup;